import { render, staticRenderFns } from "./ChooseDepart.vue?vue&type=template&id=8cd080fe&scoped=true&"
import script from "./ChooseDepart.vue?vue&type=script&lang=js&"
export * from "./ChooseDepart.vue?vue&type=script&lang=js&"
import style0 from "./ChooseDepart.vue?vue&type=style&index=0&id=8cd080fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd080fe",
  null
  
)

export default component.exports